export default "__VITE_ASSET__BHMKVYGh__"